import React from "react"
import clsx from "clsx"
import Button from "./Button"
import buttonPropTypes from "./buttonPropTypes"

const PrimaryButton = ({ className, isDark = false, ...rest }) => (
  <Button
    className={clsx("primary-button", className, isDark && "dark")}
    color="white"
    {...rest}
  />
)

PrimaryButton.propTypes = buttonPropTypes

export default PrimaryButton
